import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { listPortfolios } from '../modules/portfoliodata';
import { getTenants } from '../modules/tenantdata';
import { Grid, CircularProgress } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Footer from '../main/footer';
import { useTranslation } from 'react-i18next';

const styles = {
    table: { width: '100%', mb: '20px' },
    paper: { p: '5px' },
};

export default function PortfolioManagementView(props) {
    const portfolios = useSelector((state) => state.portfoliodata.portfolios);
    const tenants = useSelector((state) => state.tenantdata.tenants);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        if (props.active && (!portfolios || portfolios.length === 0)) {
            dispatch(listPortfolios());
        }
    }, [props.active, dispatch, portfolios]);

    useEffect(() => {
        if (props.active && (!tenants || tenants.length === 0)) {
            dispatch(getTenants());
        }
    }, [props.active, dispatch, tenants]);

    const openPortfolio = (portfolioId) => {
        props.history.push('/admin/portfolio/' + portfolioId);
    };

    const onCreate = () => {
        props.history.push('/admin/portfolio/edit/new');
    };

    const tenantName = (portfolio) => {
        const tenant = (tenants || []).find((t) => t.clusterId === portfolio.tenantCompanyClusterId);
        return tenant ? tenant.name : '';
    };

    if (!portfolios || portfolios.length === 0) {
        return (
            <Grid item xs={12}>
                <Paper sx={styles.paper}>
                    {t('general.retrievingInformation')}
                    <CircularProgress color={'secondary'} size={'1rem'} />
                </Paper>
            </Grid>
        );
    }

    return (
        <Grid item xs={12}>
            <Paper sx={styles.paper}>
                <h4>Salkut</h4>
                <Table sx={styles.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>{t('general.portfolio')}</TableCell>
                            <TableCell>{t('general.tenant')}</TableCell>
                            <TableCell>{t('admin.users')}</TableCell>
                        </TableRow>
                    </TableHead>
                    {portfolios.length > 0 && (
                        <TableBody>
                            {portfolios.map((portfolio) => (
                                <TableRow
                                    sx={{ '&:hover': { cursor: 'pointer', backgroundColor: 'lightgray', textDecoration: 'underline' } }}
                                    key={portfolio.id}
                                    onClick={() => openPortfolio(portfolio.id)}>
                                    <TableCell>{portfolio.name}</TableCell>
                                    <TableCell>{tenantName(portfolio)}</TableCell>
                                    <TableCell>{portfolio.users.map((puser) => puser.user.name).join(', ')}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    )}
                </Table>
            </Paper>
            <Footer>
                <Grid item>
                    <Button variant="contained" color="primary" name="newPortfolio" onClick={onCreate}>
                        <i className="fas fa-file"></i>
                        &nbsp;{t('admin.newPortfolio')}
                    </Button>
                </Grid>
            </Footer>
        </Grid>
    );
}
